// utils/formatting.js — Centralized number/percentage/color formatting
// Eliminates duplicate fmt/fmtPct/pctColor definitions across components.

/**
 * Format number with Italian locale (e.g. 1.234,56)
 */
export const fmt = (n, decimals = 2) =>
  n != null
    ? n.toLocaleString('it-IT', { minimumFractionDigits: decimals, maximumFractionDigits: decimals, useGrouping: true })
    : '—';

/**
 * Format number as simple fixed decimals without locale (e.g. 3.25)
 */
export const fmtVal = (v, decimals = 2) =>
  v != null ? Number(v).toFixed(decimals) : '—';

/**
 * Format percentage with sign (e.g. +12.34% or -5.67%)
 */
export const fmtPct = (n, decimals = 2) =>
  n != null ? (n >= 0 ? '+' : '') + n.toFixed(decimals) + '%' : '—';

/**
 * Tailwind color class for positive/negative values
 */
export const pctColor = (n) =>
  n >= 0 ? 'text-emerald-400' : 'text-red-400';

/**
 * Get dynamic chart theme from CSS variables (works in both dark & light mode)
 */
export const getChartTheme = () => {
  const read = (name) => getComputedStyle(document.documentElement).getPropertyValue(name).trim();
  return {
    grid: read('--chart-grid') || '#334155',
    axis: read('--chart-axis') || '#94a3b8',
    tooltipBg: read('--tooltip-bg') || '#1e293b',
    tooltipBorder: read('--tooltip-border') || '#334155',
  };
};

/**
 * Recharts tooltip style — reads CSS variables for theme-aware colors
 */
export const getTooltipStyle = () => {
  const t = getChartTheme();
  return {
    backgroundColor: t.tooltipBg,
    border: `1px solid ${t.tooltipBorder}`,
    borderRadius: '8px',
    fontSize: '13px',
  };
};

/**
 * @deprecated Use getTooltipStyle() for theme-aware tooltip. Kept for backward compat.
 */
export const TOOLTIP_STYLE = {
  backgroundColor: '#1e293b',
  border: '1px solid #334155',
  borderRadius: '8px',
  fontSize: '13px',
};
